import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Logo } from "@/components/Logo";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <footer className="border-t border-border bg-white mt-16">
        <div className="max-w-7xl mx-auto px-6 py-10 grid md:grid-cols-3 gap-8">
          <div>
            <div className="mb-3">
              <Logo className="h-9" />
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Organismo Técnico de Capacitación. Formación profesional con certificación reconocida.
            </p>
            <p className="text-sm text-muted-foreground mt-3">
              Contacto: <a href="mailto:servicios@novacert.cl" className="text-primary hover:underline">servicios@novacert.cl</a>
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-overline text-muted-foreground mb-3">Plataforma</p>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>Catálogo de cursos</li><li>Capacitación para empresas</li><li>Verificación de certificados</li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-overline text-muted-foreground mb-3">Cumplimiento</p>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>Control de asistencia (SENCE)</li><li>Certificación con folio único</li><li>Protección de datos personales</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-border py-4 text-center text-xs text-muted-foreground">
          © 2026 NovaCert OTEC · Chile
        </div>
      </footer>
    </div>
  );
}
